export { ConstrainedImgBox } from './ConstrainedImgBox';
export type { Props } from './ConstrainedImgBox.types';
